import React from 'react';
import {
  AlertOctagon, Reply, Eye, Check, Clock, Receipt, Newspaper, Archive,
  Inbox, Tag, Flag, Star, Bell, Mail, Bookmark, DollarSign,
  LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  AlertOctagon, Reply, Eye, Check, Clock, Receipt, Newspaper, Archive,
  Inbox, Tag, Flag, Star, Bell, Mail, Bookmark, DollarSign,
};

/** Resolve a lucide icon by name (used by editable stages). Falls back to Tag. */
export function StageIcon({ name, size = 15 }: { name?: string; size?: number }) {
  const Cmp = (name && MAP[name]) || Tag;
  return <Cmp size={size} />;
}

export const STAGE_ICON_CHOICES = Object.keys(MAP);
